module.exports = require("./declare.js");


//////////////////
// WEBPACK FOOTER
// ./node_modules/declare.js/index.js
// module id = IPDz
// module chunks = 32